export const MAX_FILE_SIZE = 30 * 1024 * 1024; // 30MB